if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
      const observer = new MutationObserver((MutationList) => {
        for (let item of MutationList) {
          if (item.target.classList?.contains('theme-money') || item.target.classList?.contains('all-results-container')) {
              window.dispatchEvent(new Event("scroll"));
          }
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }, 300);
}

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    const productForm = document.querySelector('[bss-b2b-product-form="main"]');
    const product = BSS_B2B.storage.productFormStorage.get(productForm.getAttribute("bss-b2b-product-form-id"))
    const card = document.querySelector('.main-product-price-container [bss-b2b-variant-id]')
    const variantId = card.getAttribute('bss-b2b-variant-id')
    
    product.currentVariant = product.variants.find(item => item.id == variantId)
    BSS_B2B.storage.productFormStorage.set(productForm.getAttribute("bss-b2b-product-form-id"), product);
    BSS_B2B?.observer?.productSubject?.notifyObserver?.('VariantChange', 'VariantSelectChange', { productForm })
  }, 2000);

  const updateAttributesAndTotal = () => {
    const inputs = document.querySelectorAll(".cbb-frequently-bought-selector-input");
    if (!inputs.length) return;

    const regularPrices = document.querySelectorAll(".cbb-frequently-bought-selector-label-regular-price");
    const salePrices = document.querySelectorAll(".cbb-frequently-bought-selector-label-sale-price");
    const comparePrices = document.querySelectorAll(".cbb-frequently-bought-selector-label-compare-at-price");

    // hide compare-at-price
    comparePrices.forEach((el) => (el.style.display = "none"));

    inputs.forEach((input, index) => {
      const nameAttr = input.getAttribute("name");
      const variantId = input.getAttribute("id");
      const productId = nameAttr ? nameAttr.replace("product_", "") : null;
      if (!productId) return;

      let priceEl = regularPrices[index];
      const saleEl = salePrices[index];

      // Nếu regular bị ẩn → fallback sang sale
      if (!priceEl || window.getComputedStyle(priceEl).display === "none") {
        priceEl = saleEl;
      }

      if (!priceEl) return;

      const priceText = priceEl.textContent.trim();
      priceEl.setAttribute("bss-b2b-product-id", productId);
      priceEl.setAttribute("bss-b2b-variant-id", variantId);
      priceEl.setAttribute("bss-b2b-product-price", priceText);
      priceEl.setAttribute("bss-b2b-collection-element", "true");
    });

    // --- Tính tổng giá ---
    setTimeout(() => {
      let total = 0;

      inputs.forEach((input, index) => {
        if (!input.checked) return;

        let priceEl =
          regularPrices[index] && window.getComputedStyle(regularPrices[index]).display !== "none"
            ? regularPrices[index]
            : salePrices[index];

        if (!priceEl) return;

        // Ưu tiên lấy số trong span cuối cùng (vì span đầu thường là giá gạch)
        const lastSpan = priceEl.querySelector("span:last-child");
        const priceText = lastSpan ? lastSpan.textContent.trim() : priceEl.textContent.trim();
        const numeric = parseFloat(priceText.replace(/[^0-9.]/g, ""));
        if (!isNaN(numeric)) total += numeric;
      });

      // --- Update vào .money (total) ---
      const totalEl = document.querySelector(".money");
      if (totalEl) {
        totalEl.textContent = `$${total.toFixed(2)}`;
      }
    }, 2000);
  };

  if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
      const observer = new MutationObserver((MutationList) => {
        for (let item of MutationList) {
          if (item.target.classList?.contains('cbb-frequently-bought-selector-label-regular-price') || 
                item.target.classList?.contains('cbb-frequently-bought-total-price-was-price')
        ) {
            console.log(123)
            updateAttributesAndTotal()
          }
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }, 300);
  }

  setTimeout(updateAttributesAndTotal, 2000);
});

